let banks = [
  {
    name: "Access Bank",
    slug: "access-bank",
    code: "044",
    ussd: "*901#",
    logo: "https://nigerianbanks.xyz/logo/access-bank.png",
  },
  {
    name: "Access Bank (Diamond)",
    slug: "access-bank-diamond",
    code: "063",
    ussd: "*426#",
    logo: "https://nigerianbanks.xyz/logo/access-bank-diamond.png",
  },
  {
    name: "ALAT by WEMA",
    slug: "alat-by-wema",
    code: "035A",
    ussd: "*945*100#",
    logo: "https://nigerianbanks.xyz/logo/alat-by-wema.png",
  },
  {
    name: "ASO Savings and Loans",
    slug: "asosavings",
    code: "401",
    ussd: "",
    logo: "https://nigerianbanks.xyz/logo/asosavings.png",
  },
  {
    name: "Bowen Microfinance Bank",
    slug: "bowen-microfinance-bank",
    code: "50931",
    ussd: "",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
  },
  {
    name: "CARBON",
    slug: "carbon",
    code: "565",
    ussd: "",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
  },
  {
    name: "CEMCS Microfinance Bank",
    slug: "cemcs-microfinance-bank",
    code: "50823",
    ussd: "",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
  },
  {
    name: "Citibank Nigeria",
    slug: "citibank-nigeria",
    code: "023",
    ussd: "",
    logo: "https://nigerianbanks.xyz/logo/citibank-nigeria.png",
  },
  {
    name: "Ecobank Nigeria",
    slug: "ecobank-nigeria",
    code: "050",
    ussd: "*326#",
    logo: "https://nigerianbanks.xyz/logo/ecobank-nigeria.png",
  },
  {
    name: "Ekondo Microfinance Bank",
    slug: "ekondo-microfinance-bank",
    code: "562",
    ussd: "*540*178#",
    logo: "https://nigerianbanks.xyz/logo/ekondo-microfinance-bank.png",
  },
  {
    name: "Fidelity Bank",
    slug: "fidelity-bank",
    code: "070",
    ussd: "*770#",
    logo: "https://nigerianbanks.xyz/logo/fidelity-bank.png",
  },
  {
    name: "First Bank of Nigeria",
    slug: "first-bank-of-nigeria",
    code: "011",
    ussd: "*894#",
    logo: "https://nigerianbanks.xyz/logo/first-bank-of-nigeria.png",
  },
  {
    name: "First City Monument Bank",
    slug: "first-city-monument-bank",
    code: "214",
    ussd: "*329#",
    logo: "https://nigerianbanks.xyz/logo/first-city-monument-bank.png",
  },
  {
    name: "Globus Bank",
    slug: "globus-bank",
    code: "00103",
    ussd: "*989#",
    logo: "https://nigerianbanks.xyz/logo/globus-bank.png",
  },
  {
    name: "Guaranty Trust Bank",
    slug: "guaranty-trust-bank",
    code: "058",
    ussd: "*737#",
    logo: "https://nigerianbanks.xyz/logo/guaranty-trust-bank.png",
  },
  {
    name: "Hasal Microfinance Bank",
    slug: "hasal-microfinance-bank",
    code: "50383",
    ussd: "*322*127#",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
  },
  {
    name: "Heritage Bank",
    slug: "heritage-bank",
    code: "030",
    ussd: "*322#",
    logo: "https://nigerianbanks.xyz/logo/heritage-bank.png",
  },
  {
    name: "Jaiz Bank",
    slug: "jaiz-bank",
    code: "301",
    ussd: "*389*301#",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
  },
  {
    name: "Keystone Bank",
    slug: "keystone-bank",
    code: "082",
    ussd: "*7111#",
    logo: "https://nigerianbanks.xyz/logo/keystone-bank.png",
  },
  {
    name: "Kuda Bank",
    slug: "kuda-bank",
    code: "50211",
    ussd: "",
    logo: "https://nigerianbanks.xyz/logo/kuda-bank.png",
  },
  {
    name: "One Finance",
    slug: "one-finance",
    code: "565",
    ussd: "*1303#",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
  },
  {
    name: "Parallex Bank",
    slug: "parallex-bank",
    code: "104",
    ussd: "*322*318*0#",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
  },
  {
    name: "Polaris Bank",
    slug: "polaris-bank",
    code: "076",
    ussd: "*833#",
    logo: "https://nigerianbanks.xyz/logo/polaris-bank.png",
  },
  {
    name: "Providus Bank",
    slug: "providus-bank",
    code: "101",
    ussd: "",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
  },
  {
    name: "Rubies MFB",
    slug: "rubies-mfb",
    code: "125",
    ussd: "*7797#",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
  },
  {
    name: "Sparkle Microfinance Bank",
    slug: "sparkle-microfinance-bank",
    code: "51310",
    ussd: "",
    logo: "https://nigerianbanks.xyz/logo/sparkle-microfinance-bank.png",
  },
  {
    name: "Stanbic IBTC Bank",
    slug: "stanbic-ibtc-bank",
    code: "221",
    ussd: "*909#",
    logo: "https://nigerianbanks.xyz/logo/stanbic-ibtc-bank.png",
  },
  {
    name: "Standard Chartered Bank",
    slug: "standard-chartered-bank",
    code: "068",
    ussd: "",
    logo: "https://nigerianbanks.xyz/logo/standard-chartered-bank.png",
  },
  {
    name: "Sterling Bank",
    slug: "sterling-bank",
    code: "232",
    ussd: "*822#",
    logo: "https://nigerianbanks.xyz/logo/sterling-bank.png",
  },
  {
    name: "Suntrust Bank",
    slug: "suntrust-bank",
    code: "100",
    ussd: "*5230#",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
  },
  {
    name: "TAJ Bank",
    slug: "taj-bank",
    code: "302",
    ussd: "*898#",
    logo: "https://nigerianbanks.xyz/logo/taj-bank.png",
  },
  {
    name: "TCF MFB",
    slug: "tcf-mfb",
    code: "51211",
    ussd: "*908#",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
  },
  {
    name: "Titan Trust Bank",
    slug: "titan-trust-bank",
    code: "102",
    ussd: "*922#",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
  },
  {
    name: "Union Bank of Nigeria",
    slug: "union-bank-of-nigeria",
    code: "032",
    ussd: "*826#",
    logo: "https://nigerianbanks.xyz/logo/union-bank-of-nigeria.png",
  },
  {
    name: "United Bank For Africa",
    slug: "united-bank-for-africa",
    code: "033",
    ussd: "*919#",
    logo: "https://nigerianbanks.xyz/logo/united-bank-for-africa.png",
  },
  {
    name: "Unity Bank",
    slug: "unity-bank",
    code: "215",
    ussd: "*7799#",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
  },
  {
    name: "VFD",
    slug: "vfd",
    code: "566",
    ussd: "",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
  },
  {
    name: "Wema Bank",
    slug: "wema-bank",
    code: "035",
    ussd: "*945#",
    logo: "https://nigerianbanks.xyz/logo/wema-bank.png",
  },
  {
    name: "Zenith Bank",
    slug: "zenith-bank",
    code: "057",
    ussd: "*966#",
    logo: "https://nigerianbanks.xyz/logo/zenith-bank.png",
  },

  //Newly Inserted banks

  {
    code: "120001",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
    name: "9mobile 9Payment Service Bank",
    slug: "9mobile-9payment-service-bank-ng",
    ussd: "",
  },
  {
    code: "801",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
    name: "Abbey Mortgage Bank",
    slug: "abbey-mortgage-bank",
    ussd: "",
  },
  {
    code: "51204",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
    name: "Above Only MFB",
    slug: "above-only-mfb",
    ussd: "",
  },
  {
    code: "51312",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
    name: "Abulesoro MFB",
    slug: "abulesoro-mfb-ng",
    ussd: "",
  },
  {
    code: "602",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
    name: "Accion Microfinance Bank",
    slug: "accion-microfinance-bank-ng",
    ussd: "",
  },
  {
    code: "50036",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
    name: "Ahmadu Bello University Microfinance Bank",
    slug: "ahmadu-bello-university-microfinance-bank-ng",
    ussd: "",
  },
  {
    code: "120004",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
    name: "Airtel Smartcash PSB",
    slug: "airtel-smartcash-psb-ng",
    ussd: "",
  },
  {
    code: "50926",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
    name: "Amju Unique MFB",
    slug: "amju-unique-mfb",
    ussd: "",
  },
  {
    code: "50083",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
    name: "Aramoko MFB",
    slug: "aramoko-mfb",
    ussd: "",
  },
  {
    code: "MFB50094",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
    name: "Astrapolaris MFB LTD",
    slug: "astrapolaris-mfb",
    ussd: "",
  },
  {
    code: "51229",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
    name: "Bainescredit MFB",
    slug: "bainescredit-mfb",
    ussd: "",
  },
  {
    code: "50171",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
    name: "Chanelle Microfinance Bank Limited",
    slug: "chanelle-microfinance-bank-limited-ng",
    ussd: "",
  },
  {
    code: "50204",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
    name: "Corestep MFB",
    slug: "corestep-mfb",
    ussd: "",
  },
  {
    code: "559",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
    name: "Coronation Merchant Bank",
    slug: "coronation-merchant-bank",
    ussd: "",
  },
  {
    code: "51297",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
    name: "Crescent MFB",
    slug: "crescent-mfb",
    ussd: "",
  },
  {
    code: "50162",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
    name: "Dot Microfinance Bank",
    slug: "dot-microfinance-bank-ng",
    ussd: "",
  },
  {
    code: "50263",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
    name: "Ekimogun MFB",
    slug: "ekimogun-mfb-ng",
    ussd: "",
  },
  {
    code: "098",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
    name: "Ekondo Microfinance Bank",
    slug: "ekondo-microfinance-bank-ng",
    ussd: "",
  },
  {
    code: "50126",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
    name: "Eyowo",
    slug: "eyowo",
    ussd: "",
  },
  {
    code: "51318",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
    name: "Fairmoney Microfinance Bank",
    slug: "fairmoney-microfinance-bank-ng",
    ussd: "",
  },
  {
    code: "51314",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
    name: "Firmus MFB",
    slug: "firmus-mfb",
    ussd: "",
  },
  {
    code: "107",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
    name: "FirstTrust Mortgage Bank Nigeria",
    slug: "firsttrust-mortgage-bank-nigeria-ng",
    ussd: "",
  },
  {
    code: "501",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
    name: "FSDH Merchant Bank Limited",
    slug: "fsdh-merchant-bank-limited",
    ussd: "",
  },
  {
    code: "812",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
    name: "Gateway Mortgage Bank LTD",
    slug: "gateway-mortgage-bank",
    ussd: "",
  },
  {
    code: "100022",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
    name: "GoMoney",
    slug: "gomoney",
    ussd: "",
  },
  {
    code: "50739",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
    name: "Goodnews Microfinance Bank",
    slug: "goodnews-microfinance-bank-ng",
    ussd: "",
  },
  {
    code: "51251",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
    name: "Hackman Microfinance Bank",
    slug: "hackman-microfinance-bank",
    ussd: "",
  },
  {
    code: "120002",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
    name: "HopePSB",
    slug: "hopepsb-ng",
    ussd: "",
  },
  {
    code: "51244",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
    name: "Ibile Microfinance Bank",
    slug: "ibile-mfb",
    ussd: "",
  },
  {
    code: "50439",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
    name: "Ikoyi Osun MFB",
    slug: "ikoyi-osun-mfb",
    ussd: "",
  },
  {
    code: "50442",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
    name: "Ilaro Poly Microfinance Bank",
    slug: "ilaro-poly-microfinance-bank-ng",
    ussd: "",
  },
  {
    code: "50457",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
    name: "Infinity MFB",
    slug: "infinity-mfb",
    ussd: "",
  },
  {
    code: "50502",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
    name: "Kadpoly MFB",
    slug: "kadpoly-mfb",
    ussd: "",
  },
  {
    code: "50200",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
    name: "Kredi Money MFB LTD",
    slug: "kredi-money-mfb",
    ussd: "",
  },
  {
    code: "90052",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
    name: "Lagos Building Investment Company Plc.",
    slug: "lbic-plc",
    ussd: "",
  },
  {
    code: "50549",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
    name: "Links MFB",
    slug: "links-mfb",
    ussd: "",
  },
  {
    code: "031",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
    name: "Living Trust Mortgage Bank",
    slug: "living-trust-mortgage-bank",
    ussd: "",
  },
  {
    code: "303",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
    name: "Lotus Bank",
    slug: "lotus-bank",
    ussd: "",
  },
  {
    code: "50563",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
    name: "Mayfair MFB",
    slug: "mayfair-mfb",
    ussd: "",
  },
  {
    code: "50304",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
    name: "Mint MFB",
    slug: "mint-mfb",
    ussd: "",
  },
  {
    code: "120003",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
    name: "MTN Momo PSB",
    slug: "mtn-momo-psb-ng",
    ussd: "",
  },
  {
    code: "100002",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
    name: "Paga",
    slug: "paga",
    ussd: "",
  },
  {
    code: "999991",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
    name: "PalmPay",
    slug: "palmpay",
    ussd: "",
  },
  {
    code: "104",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
    name: "Parallex Bank",
    slug: "parallex-bank",
    ussd: "",
  },
  {
    code: "311",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
    name: "Parkway - ReadyCash",
    slug: "parkway-ready-cash",
    ussd: "",
  },
  {
    code: "999992",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
    name: "Paycom (Opay)",
    slug: "paycom",
    ussd: "",
  },
  {
    code: "51146",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
    name: "Personal Trust MFB",
    slug: "personal-trust-mfb-ng",
    ussd: "",
  },
  {
    code: "50746",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
    name: "Petra Mircofinance Bank Plc",
    slug: "petra-microfinance-bank-plc",
    ussd: "",
  },
  {
    code: "50864",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
    name: "Polyunwana MFB",
    slug: "polyunwana-mfb-ng",
    ussd: "",
  },
  {
    code: "105",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
    name: "PremiumTrust Bank",
    slug: "premiumtrust-bank-ng",
    ussd: "",
  },
  {
    code: "51293",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
    name: "QuickFund MFB",
    slug: "quickfund-mfb",
    ussd: "",
  },
  {
    code: "502",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
    name: "Rand Merchant Bank",
    slug: "rand-merchant-bank",
    ussd: "",
  },
  {
    code: "90067",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
    name: "Refuge Mortgage Bank",
    slug: "refuge-mortgage-bank",
    ussd: "",
  },
  {
    code: "50767",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
    name: "ROCKSHIELD MICROFINANCE BANK",
    slug: "rockshield-microfinance-bank-ng",
    ussd: "",
  },
  {
    code: "51113",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
    name: "Safe Haven MFB",
    slug: "safe-haven-mfb-ng",
    ussd: "",
  },
  {
    code: "951113",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
    name: "Safe Haven Microfinance Bank Limited",
    slug: "safe-haven-microfinance-bank-limited-ng",
    ussd: "",
  },
  {
    code: "50582",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
    name: "Shield MFB",
    slug: "shield-mfb-ng",
    ussd: "",
  },
  {
    code: "50800",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
    name: "Solid Rock MFB",
    slug: "solid-rock-mfb",
    ussd: "",
  },
  {
    code: "51253",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
    name: "Stellas MFB",
    slug: "stellas-mfb",
    ussd: "",
  },
  {
    code: "50968",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
    name: "Supreme MFB",
    slug: "supreme-mfb-ng",
    ussd: "",
  },
  {
    code: "090560",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
    name: "Tanadi Microfinance Bank",
    slug: "tanadi-microfinance-bank-ng",
    ussd: "",
  },
  {
    code: "51269",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
    name: "Tangerine Money",
    slug: "tangerine-money",
    ussd: "",
  },
  {
    code: "100039",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
    name: "Titan Paystack",
    slug: "titan-paystack",
    ussd: "",
  },
  {
    code: "MFB51322",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
    name: "Uhuru MFB",
    slug: "uhuru-mfb-ng",
    ussd: "",
  },
  {
    code: "50870",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
    name: "Unaab Microfinance Bank Limited",
    slug: "unaab-microfinance-bank-limited-ng",
    ussd: "",
  },
  {
    code: "50871",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
    name: "Unical MFB",
    slug: "unical-mfb",
    ussd: "",
  },
  {
    code: "51316",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
    name: "Unilag Microfinance Bank",
    slug: "unilag-microfinance-bank-ng",
    ussd: "",
  },
];

export default banks;
